module.exports = __webpack_public_path__ + "img/27.6c8a388b.jpg";